export default __webpack_public_path__ + "static/media/weikfield.b0938c1f.svg";